// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { Glyphicon } from 'react-bootstrap';

export default class EntertainmentElement extends React.PureComponent {
  deleteEntertainment = event => {
    event.stopPropagation();
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { actions } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    actions.deleteEntertainment(
      event.currentTarget.getAttribute('data-name'),
      'entertainments'
    );
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { value, ind, notHeader, entertainments } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    const entertainment = entertainments.find(ent => ent.id === value);
    const topBorder = notHeader && ind === 0 ? 'none' : '';
    return (
      <tr key={value} data-name={ind} className='listrow moveable'>
        <td style={{ verticalAlign: 'middle', borderTop: topBorder }}>
          <Glyphicon glyph='option-vertical' />
        </td>
        <td style={{ width: '10%', borderTop: topBorder, minWidth: '60px' }}>
          {' '}
          <img
            src={entertainment.picture}
            style={{ width: '48px', height: '48px' }}
            alt='...'
            className='img-thumbnail'
          />
        </td>
        <td
          style={{
            width: '90%',
            verticalAlign: 'middle',
            borderTop: topBorder,
          }}
        >
          {entertainment.title}
        </td>
        <td
          style={{
            width: '5%',
            textAlign: 'center',
            verticalAlign: 'middle',
            cursor: 'pointer',
            borderTop: topBorder,
          }}
        >
          <i
            className='fas fa-times'
            style={{ cursor: 'pointer' }}
            data-name={ind}
            onClick={this.deleteEntertainment}
          />
        </td>
      </tr>
    );
  }
}
